import React from 'react';

import { Currency } from '@/constants';
import { ResultUtxo } from '@/networks/btc-like/common/transactions/api';
import { cn } from '@/utils';

import { UtxoSelectCard } from './UtxoSelectCard';

interface UtxoSelectGridProps {
  utxos: ResultUtxo[];
  isShowFiatValue?: boolean;
  selectedUtxos: ResultUtxo[];
  onUtxoSelect: (utxo: ResultUtxo) => void;
  className?: string;
  currency: Currency;
}

const UtxoSelectGrid: React.FC<UtxoSelectGridProps> = ({
  utxos,
  selectedUtxos,
  onUtxoSelect,
  className,
  isShowFiatValue,
  currency,
}) => {
  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {utxos.map((utxo) => {
        return (
          <UtxoSelectCard
            currency={currency}
            key={`${utxo.txid}:${utxo.vout}`}
            className="min-w-[220px] flex-1"
            utxo={utxo}
            isSelected={selectedUtxos.some((selected) => selected.txid === utxo.txid && selected.vout === utxo.vout)}
            onClick={() => onUtxoSelect(utxo)}
            isShowFiatValue={isShowFiatValue}
          />
        );
      })}
    </div>
  );
};

export default UtxoSelectGrid;
